import React from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Button } from '@mui/material'
import LocalShippingIcon from '@mui/icons-material/LocalShipping'

export default function LogisticaButton() {
    const { roles } = useSelector(state => state.account)
    const navigate = useNavigate()

    if (!roles.includes("Administrador")) return null

    return (
        <Button
            color="inherit"
            onClick={() => navigate("/logistica")}
            startIcon={<LocalShippingIcon />}
            sx={{ minWidth: "unset" }}
        >
            Logística
        </Button>
    )
}
